import { render } from "./AlertEditor.vue?vue&type=template&id=21605284&scoped=true"
import script from "./AlertEditor.vue?vue&type=script&lang=js"
export * from "./AlertEditor.vue?vue&type=script&lang=js"

import "./AlertEditor.vue?vue&type=style&index=0&id=21605284&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21605284"]])

export default __exports__